import { useCallback, useState, useEffect, useRef } from "react"

const useMeasureRect = <T extends HTMLElement>(
  callback?: () => T
): ClientRect | DOMRect => {
  const savedCallback = useRef<() => T>()
  const [rect, set] = useState<ClientRect | DOMRect>({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  })

  // 保持新回调
  useEffect(() => {
    savedCallback.current = callback
  })

  const measure = useCallback(() => {
    if (savedCallback.current) {
      let node = savedCallback.current()
      if (node) {
        const rect = node.getBoundingClientRect()
        set(rect)
      }
    }
  }, [savedCallback])

  // measure
  useEffect(() => {
    measure()
  }, [measure])

  return rect
}

export default useMeasureRect
